//dependencies
import dropdown from "angular-ui-bootstrap/src/dropdown";
import collapse from "angular-ui-bootstrap/src/collapse";
import tabs from "angular-ui-bootstrap/src/tabs";
import ngSanitize from "angular-sanitize";

//services

//components
import permissionListManager from "emun.auth/permissions/permission-list-manager";
import rolePermissionsEditor from "emun.auth/permissions/role-permissions-editor";

export const dependencies = [dropdown, collapse, tabs, ngSanitize];

export const modules = {
  // modals,
};
//states
import states from "emun.auth/permissions/permissions.states";

export const services = {};

export const components = {
  permissionListManager,
  rolePermissionsEditor
};

export const directives = {};

export default {
  modules,
  services,
  dependencies,
  components,
  directives,
  states
};
